import back from "../assets/images/back.png";
import next from "../assets/images/next.png";
import React from "react";
import moment from "moment/moment";

const prevDay = (date) => {
    const d = new Date(date);
    d.setDate(d.getDate() - 1);
    return d.toISOString().split('T')[0];
};

const nextDay = (date) => {
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    return d.toISOString().split('T')[0];
};

export const today = moment().format("YYYY-MM-DD");
export const nextDayN = (n = 1) => moment().add({day: n}).format("YYYY-MM-DD");


const Calendar = ({date, onChangeDate}) => {

    const handlePrev = () => {
        onChangeDate(prevDay(date))
    };
    const handleNext = () => {
        if (date < today) {
            onChangeDate(nextDay(date))
        }
    };

    const onClickDate = () => {
        if (window?.showCalendar) {
            window.showCalendar('sel3', '%Y-%m-%d', onChangeDate);
        }
    };


    return <div className="text-left">
        <table align="center" className="border-collapse">
            <tbody>
            <tr>
                <td width="25" className="img-date">
                    <img src={back} height="25" alt="Previous" onClick={handlePrev} className="cursor-pointer"/>
                </td>
                <td>
                    <div className="input-date">
                        <input
                            className="form-control custom-input"
                            type="text"
                            name="date"
                            id="sel3"
                            value={date}
                            onClick={onClickDate}
                            readOnly
                        />
                        <span id="calendar-trigger" style={{display: 'block'}}/>
                    </div>
                </td>
                <td width="25" className="img-date">
                    <img
                        src={next}
                        height="25"
                        alt="Next"
                        onClick={handleNext}
                        className="cursor-pointer"
                    />
                </td>
            </tr>
            </tbody>
        </table>
    </div>
}

export default Calendar;